import { axiosGetHandler,  axiosPostHandler } from '../config'

//  获取活动数据
export function getCompilationData (args) {
	let url = '/game/h5_activity/game_compilation_detail'
	return axiosGetHandler(url, args)
}